import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";

const getIsMobile = createSelector(
  [getUserAgent],
  (userAgent) => userAgent.isMobile,
);

export default getIsMobile;
